"use client";

import React, {useMemo} from "react";
import {Card} from "@/app/pwa/components/Card";

;
import {PlayerCardSmall} from "@/app/pwa/components/player/PlayerCardSmall";
import {
  SquadPosition,
  SquadPositionData,
} from "@/sources/kicker-amateur/types";
import {UserInfo} from "@/sources/kicker-ovsyndication";
import NoContent from "@/app/pwa/components/NoContent";

const Position = React.memo(
  ({
     position,
     teamId,
   }: {
    position: SquadPosition;
    teamId: number;
  }) => {
    const title = useMemo(() => {
      return `${position.Position === "Unknown" ? "Ohne Position" : position.Position} (${position.Players.length})`;
    }, [position]);

    return (
      <>
        {position.Players.length > 0 &&
          <Card p={false} className="border-b border-gray-150">
            <div className="flex justify-between border-b border-gray-150 pl-4 items-center">
              <h5 className={`font-bold text-lg py-2`}>{title}</h5>
            </div>
            <div className="p-4 grid @xl/card:grid-cols-2 @4xl/card:grid-cols-3 @6xl/card:grid-cols-4 gap-4">
              {position.Players.sort((a, b) => {
                return a.LastName?.localeCompare(b.LastName ?? "") ?? 0
              }).map((player) => (
                <PlayerCardSmall
                  key={player.Id}
                  teamId={teamId}
                  player={player}
                  showInvite={false}
                  widget={true}
                />
              ))}
            </div>
          </Card>
        }
      </>
    );
  }
);
Position.displayName = "Position";

export const Positions = React.memo(
  ({
     positionsData,
     teamId,
   }: {
    positionsData: SquadPositionData;
    teamId: number;
  }) => (
    <div>
      {positionsData.Positions.map((position) => (
        <Position
          key={position.Id}
          position={position}
          teamId={teamId}
        />
      ))}
    </div>
  )
);
Positions.displayName = "Positions";

interface TeamSquadPageProps {
  positionsData: SquadPositionData;
  teamId: number;
  alreadyInvitedPeople: { [amaPersonId: number]: boolean };
  user?: UserInfo
}

export function TeamSquadWidget({
                                  positionsData,
                                  teamId,
                                }: TeamSquadPageProps) {

  const totalPlayers = useMemo(() => {
    return positionsData.Positions.reduce(
      (sum, position) => sum + position.Players.length,
      0
    );
  }, [positionsData]);

  return (
    <div>
      {totalPlayers > 0 ? (
        <Positions
          positionsData={positionsData}
          teamId={teamId}
        />
      ) : (
        <NoContent className="gap-2 text-center">
          <h2 className=" font-condensed text-lg font-semibold">
            Der Kader ist noch leer
          </h2>
          <p className="max-w-64">
            Wenn du den Kader erstellen möchtest, frage bitte den
            Verantwortlichen für diesen Verein.
          </p>
        </NoContent>
      )}
    </div>
  );
};
